module.exports = __webpack_public_path__ + "static/media/logo.f5ceec72.png";